import { render, staticRenderFns } from "./rfq-view.vue?vue&type=template&id=be48c972&scoped=true"
import script from "./rfq-view.vue?vue&type=script&lang=js"
export * from "./rfq-view.vue?vue&type=script&lang=js"
import style0 from "./rfq-view.vue?vue&type=style&index=0&id=be48c972&prod&lang=scss&scoped=true"
import style1 from "./rfq-view.vue?vue&type=style&index=1&id=be48c972&prod&lang=css"
import style2 from "./rfq-view.vue?vue&type=style&index=2&id=be48c972&prod&scoped=true&lang=css"
import style3 from "./rfq-view.vue?vue&type=style&index=3&id=be48c972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be48c972",
  null
  
)

export default component.exports